const getDefaultState = () => {
  return {
    nodeMap: new Map(),
    isEdit: false, // 流程是新增or编辑
    selectedNode: {},
    design: {}
  }
}

const state = getDefaultState()

const mutations = {
  selectedNode(state, val) {
    state.selectedNode = val
  },
  loadForm(state, val) {
    state.design = val
  },
  setIsEdit(state, val) {
    state.isEdit = val
  }
}

export default {
  namespaced: true,
  state,
  mutations
}
